import { SVG, SVGProps } from './svg'

export function IconCaretVertical(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M18 8c0-.2 0-.4-.2-.5l-5.3-5.3a.7.7 0 0 0-1 0L6.2 7.5a.7.7 0 0 0 0 1l.3.3.5.2h10c.2 0 .4 0 .5-.2l.3-.3.2-.5ZM6 16c0 .2 0 .4.2.5l5.3 5.3a.7.7 0 0 0 1 0l5.3-5.3a.7.7 0 0 0 0-1l-.3-.3a.7.7 0 0 0-.5-.2H7c-.2 0-.4 0-.5.2l-.3.3-.2.5Z" />
    </SVG>
  )
}
